import http from "@/axios/http-common";

// APGAR ringkas dari Asesmen Awal Bayi Baru Lahir (IMP-066)
export interface ApgarBbl {
  id: number;
  register_id: number;
  apgar_1: number | null;
  apgar_5: number | null;
  apgar_10: number | null;
  apgar_interpretasi: string | null;
  komponen: { [menit: string]: { [komp: string]: number } } | null;
}

// Ambil APGAR dari BBL (cocok register bayi atau register ibu).
// Return null bila tidak ada BBL atau APGAR belum terisi.
export async function fetchApgarBbl(register: any): Promise<ApgarBbl | null> {
  const reg = register && typeof register === "object" ? register.no : register;
  if (!reg) return null;
  try {
    const res = await http.getData(`/register/${reg}/apgar-bbl`);
    const d = res && res.data ? res.data.data : null;
    if (!d || (d.apgar_1 == null && d.apgar_5 == null && d.apgar_10 == null)) return null;
    return d;
  } catch (e) {
    return null;
  }
}

function val(v: any) {
  return v === undefined || v === null ? null : v;
}

// Map komponen BBL (djantung/napas/tonus/reflex/warna) → field Identitas Bayi
export function bblKomponenToIdentitas(k: any) {
  k = k || {};
  return {
    frekuensi_jantung: val(k.djantung),
    usaha_bernafas: val(k.napas),
    tonus_otot: val(k.tonus),
    iritabilitas_refleks: val(k.reflex),
    warna_kulit: val(k.warna)
  };
}
